import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { FiMenu, FiX } from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import ComicButton from '../ui/ComicButton';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const logoUrl = "https://static.wixstatic.com/media/9fff18_7f77218ff74e4a6a93c1ad8122a0c3d3~mv2.png/v1/fill/w_288,h_286,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/thumbnail%20(3).png";

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'Line Up', path: '/lineup' },
    { name: 'Program', path: '/program' },
    { name: 'About', path: '/about' },
    { name: 'Merch', path: '/merch' },
    { name: 'FAQ', path: '/faq' },
  ];

  return (
    <nav className="sticky top-0 z-50 bg-white border-b-4 border-black px-4 py-2 shadow-comic relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-2 bg-hcf-gradient"></div>
      <div className="max-w-7xl mx-auto flex justify-between items-center pt-2">
        <NavLink to="/" className="flex items-center gap-3 group">
          <div className="w-16 h-16 bg-white border-4 border-black shadow-comic-sm transform -rotate-3 group-hover:rotate-0 transition-transform flex items-center justify-center p-1 overflow-hidden">
            <img src={logoUrl} alt="HCF Logo" className="w-full h-full object-contain" />
          </div>
          <div className="hidden md:block">
            <span className="font-comic text-2xl uppercase tracking-tighter leading-none block text-black">Hastings</span>
            <span className="font-comic text-xl uppercase tracking-widest text-hcf-pink leading-none drop-shadow-[1px_1px_0_rgba(0,0,0,1)]">Comedy Festival</span>
          </div>
        </NavLink>

        <div className="hidden md:flex items-center gap-6">
          {navItems.map((item) => (
            <NavLink 
              key={item.name} 
              to={item.path} 
              className={({ isActive }) => `
                font-comic text-xl uppercase tracking-wide transition-all hover:-translate-y-1
                ${isActive ? 'text-hcf-pink underline decoration-4 underline-offset-4 decoration-hcf-cyan' : 'text-black hover:text-hcf-pink'}
              `}
            >
              {item.name}
            </NavLink>
          ))}
          <ComicButton variant="primary" className="text-sm py-2 px-4 bg-hcf-yellow text-black hover:bg-black hover:text-white border-black">
            Buy Tickets
          </ComicButton>
        </div>

        <button 
          className="md:hidden text-3xl p-1 border-2 border-black bg-white text-hcf-pink"
          onClick={() => setIsOpen(!isOpen)}
        >
          <SafeIcon icon={isOpen ? FiX : FiMenu} />
        </button>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden absolute top-full left-0 w-full bg-white border-b-4 border-black shadow-comic-sm p-4 flex flex-col gap-4 z-50">
          {navItems.map((item) => (
            <NavLink 
              key={item.name} 
              to={item.path} 
              onClick={() => setIsOpen(false)}
              className="font-comic text-2xl uppercase text-center py-2 hover:bg-hcf-yellow border-2 border-transparent hover:border-black transition-colors"
            >
              {item.name}
            </NavLink>
          ))}
        </div>
      )}
    </nav>
  );
};

export default Navbar;